
const about = {
  // About Us
  about: {
    title: "About",
    predictions: "Predictions",
    intro: "We are revolutionizing sports betting through cutting-edge artificial intelligence and data analytics. Our mission is to provide accurate, data-driven predictions that help bettors make informed decisions.",
    mission: "Our Mission",
    missionText1: "At Titan Predictions, we believe that sports betting should be based on data, not luck. Our advanced AI algorithms analyze thousands of data points to provide you with the most accurate predictions possible.",
    missionText2: "We combine machine learning, statistical analysis, and expert knowledge to create predictions that give you a real edge in your betting strategy.",
    missionText3: "Our goal is to democratize access to professional-grade sports analytics, making it available to everyone from casual bettors to serious investors.",
    aiPowered: "AI-Powered Analytics",
    aiPoweredText: "Advanced machine learning algorithms process vast amounts of data to deliver precise predictions",
    whyChoose: "Why Choose Titan Predictions?",
    whyText: "Our platform offers unique advantages that set us apart from traditional betting resources and other prediction services.",
    features: {
      ai: {
        title: "Advanced AI",
        description: "State-of-the-art algorithms trained on millions of data points for precise predictions."
      },
      accuracy: {
        title: "Proven Accuracy",
        description: "Consistently high win rates validated through rigorous historical testing."
      },
      insights: {
        title: "Deep Insights",
        description: "Beyond simple predictions, understand the factors driving outcomes."
      },
      strategies: {
        title: "Smart Strategies",
        description: "Optimal betting approaches tailored to maximize returns and manage risk."
      },
      responsible: {
        title: "Responsible Betting",
        description: "Tools and guidance to encourage sustainable and responsible betting practices."
      },
      innovation: {
        title: "Constant Innovation",
        description: "Regular updates and improvements based on the latest research and data analysis."
      }
    },
    journey: "Our Journey",
    journeyText: "From a small team of data enthusiasts to a leading sports prediction platform, discover how we've grown over the years.",
    timeline: {
      "2019": {
        title: "Foundation",
        description: "Titan Predictions was founded by a team of data scientists and sports enthusiasts with a vision to revolutionize sports betting."
      },
      "2020": {
        title: "AI Development",
        description: "We developed our first machine learning models and began testing our prediction algorithms on historical data."
      },
      "2021": {
        title: "Platform Launch",
        description: "Our beta platform launched with basic prediction features for major football leagues."
      },
      "2022": {
        title: "Expansion",
        description: "We expanded to cover multiple sports and leagues, improving our accuracy rates significantly."
      },
      "2023": {
        title: "Advanced Features",
        description: "Introduction of real-time analytics, advanced betting strategies, and mobile optimization."
      }
    },
    ready: "Ready to Get Started?",
    readyText: "Join thousands of successful bettors who trust Titan Predictions for their sports betting strategy.",
    viewPricing: "View Pricing Plans",
    tryEngine: "Try Titan Engine"
  }
};

export default about;
